import styled from 'styled-components';

export const Container = styled.div`
  .modal-body {
    position: relative;
    flex: 1 1 auto;
    padding: 1rem;

    &.scroll-modal {
      overflow-x: hidden;
      overflow-y: scroll;
      max-height: 75vh;
    } 
  }

  .close {
    color: ${(props) => props.theme.$black} !important;
    font-size: 18px !important;
  }
}
`;
